import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'best-efforts-dc-reprice-modal',
    styleUrls: ['./best-efforts-dc-reprice-modal.component.sass'],
    templateUrl: './best-efforts-dc-reprice-modal.component.html'
})

export class BestEffortsDcRepriceModalComponent {
    @Input() originalAgentFeeRate: number;
    @Input() newAgentFeeRate: number;
    @Input() ShowRepriceBox: boolean;

    showWarning: boolean = false; // controls #wa section

    @Output() proceed = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor(public activeModal: NgbActiveModal) { }

    onProceed() {
        this.activeModal.close('proceed');
    }

    onCancel() {
        this.showWarning = true; // show warning section
    }

    cancelModalNo() {
        this.showWarning = false; // hide warning, show reprice modal again
    }

    cancelModalYes() {
        this.activeModal.close('cancel-confirmed'); // close modal, parent handles navigation
    }
}
